<template>
  <div id="box">
    <Header2></Header2>
    <!-- <video src="/src/assets/video/1.mp4" autoplay loop></video> -->
    <img
      src="../../public/img/goin/goin-banner.jpg"
      alt=""
      class="responsive-img"
    />

    <div class="num-box" ref="numBox">
      <div class="num-item" :class="{ show: showNum }">
        <p>{{ animatedArea }}<span>㎡</span></p>
        <p>占地面积</p>
      </div>
      <div class="num-item" :class="{ show: showNum }">
        <p>{{ animatedInvest }}<span>元</span></p>
        <p>总投资额</p>
      </div>
      <div class="num-item" :class="{ show: showNum }">
        <p>{{ animatedOutput }}<span>亿元</span></p>
        <p>年产值</p>
      </div>
    </div>

    <section class="section1">
      <div class="section-content1">
        <h1 class="section-title">企业简介</h1>
        <div class="text-box" v-html="GoinData.aboutn">
        </div>
        <!-- <img
          class="text-img"
          src="../../public/img/goin/1走进企业xiu-_03.png"
          alt=""
        /> -->
        <video
          src="https://qiniu.dongbaqu.com/fuluwei/uploads/20260104/xianyou1.mp4"
          autoplay
          loop
          muted
          playsinline
          class="responsive-video"
        ></video>
      </div>
      <!-- —————————————————————————————————————————————————————————————————————————————————— -->
      <div class="section-content1" style="display: none">
        <h1 class="section-title">发展历程</h1>
        <!-- 所有阶段年份一行展示 -->
        <div class="timeline-all-years">
          <div class="timeline-all-years-wrap">
            <template v-for="(stage, sIdx) in timeline">
              <div
                v-for="year in stage.list"
                :key="year.id"
                class="timeline-year-card"
              >
                <span class="timeline-year-label">{{ year.title }}</span>
                <div class="timeline-year-content" v-html="year.content"></div>
              </div>
              <!-- 阶段分割线 -->
              <div
                v-if="sIdx < timeline.length - 1"
                :key="'sep-' + sIdx"
                class="separator"
              >
                <span class="stage-tag">{{ timeline[sIdx + 1].name }}</span>
              </div>
            </template>
          </div>
        </div>
        <!-- 时间轴上方内容展示区（保留原功能，点击年份时展示详情） -->
        <div class="timeline-top-content" ref="timelineTop" v-show="false">
          <div class="timeline-stage-panel">
            <div
              v-for="year in timeline[currentIndex].list"
              :key="year.id"
              class="timeline-year-item"
            >
              <span class="timeline-year-label">{{ year.title }}</span>
              <div class="timeline-year-content" v-html="year.content"></div>
            </div>
          </div>
        </div>
        <!-- 横向时间轴容器（保留原功能） -->
        <div class="timeline-box" @wheel.prevent="onWheel">
          <!-- 顶部时间轴线 -->
          <div class="timeline-progress-container">
            <div class="timeline-line"></div>
            <div class="timeline-progress" ref="timelineProgress"></div>
          </div>
          <!-- 时间轴节点 -->
          <div class="timeline-track" ref="timelineTrack">
            <div
              class="timeline-stage-node"
              v-for="(stage, idx) in timeline"
              :key="stage.id"
              :class="{ active: idx === currentIndex }"
              @click="setStage(idx)"
            >
              <span class="timeline-dot"></span>
              <span class="timeline-stage-name">{{ stage.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- —————————————————————————————————————————————————————————————————————————————————— -->
    </section>

    <section class="section-content1">
      <h1 class="section-title fazhan-title">发展历程</h1>
      <div class="history-box" v-if="historyData.length && categoryData.length">
        <div class="fazhan-text text-2012">
          <h2>{{ historyData[0].title }}</h2>
          <p v-html="historyData[0].content"></p>
        </div>
        <div class="fazhan-text text-2014">
          <h2>{{ historyData[2].title }}</h2>
          <p v-html="historyData[2].content"></p>
        </div>
        <div class="fazhan-text text-2016">
          <h2>{{ historyData[3].title }}</h2>
          <p v-html="historyData[3].content"></p>
        </div>
        <div class="fazhan-text text-2023">
          <h2>{{ historyData[5].title }}</h2>
          <p v-html="historyData[5].content"></p>
        </div>
        <div class="fazhan-text text-2027">
          <h2>{{ historyData[8].title }}</h2>
          <p v-html="historyData[8].content"></p>
        </div>
        <!-- ---------------上----------- -->
        <div class="fazhan-stage b-2012-2016">{{ categoryData[0].name }}</div>
        <div class="fazhan-stage b-2017-2021">{{ categoryData[1].name }}</div>
        <div class="fazhan-stage b-2022-2026">{{ categoryData[2].name }}</div>
        <div class="fazhan-stage b-2027-2031">{{ categoryData[3].name }}</div>
        <!------------------下----------- -->
        <div class="fazhan-text text-2013">
          <p v-html="historyData[1].content"></p>
          <h2>{{ historyData[1].title }}</h2>
        </div>
        <div class="fazhan-text text-2019">
          <p v-html="historyData[4].content"></p>
          <h2>{{ historyData[4].title }}</h2>
        </div>
        <div class="fazhan-text text-2024">
          <p v-html="historyData[6].content"></p>
          <h2>{{ historyData[6].title }}</h2>
        </div>
        <div class="fazhan-text text-2025">
          <p v-html="historyData[7].content"></p>
          <h2>{{ historyData[7].title }}</h2>
        </div>
      </div>
    </section>
    <section class="section2">
      <div class="section-content1">
        <h1 class="section-title">企业文化</h1>
        <div class="dap" style="background-image: url('/img/goin/da_02.jpg')">
          <div>
            <h2>愿景</h2>
            <p>成为受客户信赖的食品服务商</p>
          </div>
          <div>
            <h2>使命</h2>
            <p>让世界变得有滋有味</p>
          </div>
          <div>
            <h2>核心价值观</h2>
            <p>诚信&nbsp;&nbsp;专业&nbsp;&nbsp;责任&nbsp;&nbsp;拼搏</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section3">
      <div class="section-content1">
        <h1 class="section-title section-title2">载誉而行  见证不凡</h1>
        <p class="honor-text" v-html="GoinData.rongyu">
        </p>
        <div class="lunbo2">
          <div class="swiper-button-prev swiper-button-prev-honor"></div>
          <div
            class="swiper-button-next swiper-button-next-honor"
            style="background: rgb(230, 0, 19)"
          ></div>
          <Swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="0"
            :breakpoints="{
              320: { slidesPerView: 1, grid: { rows: 1 } },
              768: { slidesPerView: 1, grid: { rows: 1 } },
              1024: { slidesPerView: 1, grid: { rows: 2 } },
            }"
            :loop="true"
            :autoplay="{ delay: 10000, disableOnInteraction: false }"
            :navigation="{
              prevEl: '.swiper-button-prev-honor',
              nextEl: '.swiper-button-next-honor',
            }"
            :slides-offset-after="0"
            :normalize-slide-index="true"
            @slide-change-transition-end="onHonorSlideChange"
            class="honor-swiper"
          >
            <SwiperSlide
              v-for="(group, gIdx) in honorGroups"
              :key="gIdx"
              class="honor-slide"
              style="max-width: 100%; margin: 0 auto"
            >
              <div v-for="(item, idx) in group" :key="idx">
                <div class="honor-box">
                  <img
                    :src="item.image"
                    alt="荣誉资质"
                    @click="openModal(item.image)"
                  />
                </div>
                <p class="honor-desc">{{ item.title }}</p>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>

    <!-- 荣誉资质图片放大模态框 -->
    <div v-if="modalVisible" class="modal-mask" @click="closeModal">
      <img
        :src="modalSrc"
        class="modal-img"
        @click.stop
        @error="modalSrc = modalSrc.replace('@2x', '')"
      />
      <span class="modal-close" @click="closeModal">&times;</span>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import apiServe from "@/services/index.js";
import Header2 from "@/components/HeaderView2.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Footer from "@/components/FooterView.vue";
export default {
  components: {
    Header2,
    Swiper,
    SwiperSlide,
    Footer,
  },
  setup() {
    return {
      modules: [Pagination, Autoplay, Navigation],
    };
  },
  data() {
    return {
      GoinData: {},
      indexData: {},
      currentIndex: 0,
      currentStage: null,
      activeYear: null,
      timeline: [{ list: [] }],
      banners: [
        "/img/goin/123_03.png",
        "/img/goin/123_03.png",
        "/img/goin/123_03.png",
        "/img/goin/123_03.png",
        "/img/goin/123_03.png",
      ],
      honorImages: [
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
        "/img/goin/zhizhao_06.png",
      ],
      // 动画相关
      showNum: false,
      animatedArea: 0,
      animatedInvest: 0,
      animatedOutput: 0,
      // 模态框相关
      modalVisible: false,
      modalSrc: "",
      // 发展历程数据
      historyData: [],
      categoryData: [],
      copywriting: {},
    };
  },
  computed: {
    honorGroups() {
      const size = window.innerWidth <= 768 ? 1 : 8;
      const groups = [];
      for (let i = 0; i < this.honorImages.length; i += size) {
        groups.push(this.honorImages.slice(i, i + size));
      }
      return groups;
    },
    allYears() {
      // 打平所有阶段的年份节点，用于一行横向展示
      return this.timeline.reduce((arr, stage) => arr.concat(stage.list), []);
    },
  },
  created() {},
  mounted() {
    this.initAnimations();
    this.fetchData();
    // 数字区域监听将在 getIndexData 成功后由 $nextTick 触发

    // 默认显示第一个阶段
    if (this.timeline && this.timeline.length) {
      this.currentIndex = 0;
    }
    // 监听滚轮事件
    this.$nextTick(() => {
      const box = this.$el.querySelector(".timeline-box");
      if (box) box.addEventListener("wheel", this.onWheel, { passive: false });
      this.bindTimelineScroll();
    });
  },
  beforeUnmount() {
    const box = this.$el.querySelector(".timeline-box");
    if (box) box.removeEventListener("wheel", this.onWheel);
    if (this.numObserver) this.numObserver.disconnect();
    if (this.animationObserver) this.animationObserver.disconnect();
  },
  beforeUnmount() {
    const box = this.$el.querySelector(".timeline-box");
    if (box) box.removeEventListener("wheel", this.onWheel);
    if (this.numObserver) this.numObserver.disconnect();
    if (this.animationObserver) this.animationObserver.disconnect();
  },
  methods: {
    bindTimelineScroll() {
      const scrollBox = this.$el.querySelector(".timeline-all-years");
      if (!scrollBox) return;
      // 添加拖拽滚动相关变量
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let animationFrameId = null;
      // 惯性滚动相关变量
      let velocity = 0;
      let lastTime = 0;
      let lastX = 0;
      let inertiaAnimationId = null;

      // 鼠标滚轮滚动处理
      scrollBox.addEventListener(
        "wheel",
        (e) => {
          if (isDragging) return; // 拖拽时禁用滚轮
          e.preventDefault();
          const delta = e.deltaY > 0 ? 80 : -80;
          // 使用requestAnimationFrame优化滚动流畅度
          animationFrameId = requestAnimationFrame(() => {
            scrollBox.scrollLeft += delta;
          });
        },
        { passive: false }
      );

      // 鼠标按下开始拖拽
      scrollBox.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.clientX;
        startScrollLeft = scrollBox.scrollLeft;
        lastX = e.clientX;
        lastTime = performance.now();
        velocity = 0;
        // 取消任何正在进行的惯性滚动
        if (inertiaAnimationId) {
          cancelAnimationFrame(inertiaAnimationId);
        }
        scrollBox.style.cursor = "grabbing";
        scrollBox.style.userSelect = "none"; // 防止拖拽时选中文本
        document.body.style.userSelect = "none";
      });

      // 鼠标移动处理拖拽
      scrollBox.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime;
        const x = e.clientX;
        const deltaX = x - lastX;
        // 计算速度 (像素/毫秒)
        if (deltaTime > 0) {
          velocity = deltaX / deltaTime;
        }
        lastX = x;
        lastTime = currentTime;

        const walk = (x - startX) * 1.2; // 1.2倍速度使拖拽更灵敏
        animationFrameId = requestAnimationFrame(() => {
          scrollBox.scrollLeft = startScrollLeft - walk;
        });
      });

      // 惯性滚动函数
      const inertiaScroll = () => {
        if (Math.abs(velocity) < 0.1) return;

        // 应用阻尼
        const maxScroll = scrollBox.scrollWidth - scrollBox.clientWidth;
        scrollBox.scrollLeft = Math.max(
          0,
          Math.min(scrollBox.scrollLeft + velocity * 16, maxScroll)
        ); // 假设约16ms一帧并限制边界

        inertiaAnimationId = requestAnimationFrame(inertiaScroll);
      };

      // 鼠标释放结束拖拽
      const endDrag = () => {
        if (!isDragging) return;
        isDragging = false;
        scrollBox.style.cursor = "grab";
        scrollBox.style.userSelect = "";
        document.body.style.userSelect = "";
        cancelAnimationFrame(animationFrameId);

        // 如果速度足够大，启动惯性滚动
      };

      scrollBox.addEventListener("mouseup", endDrag);
      scrollBox.addEventListener("mouseleave", endDrag);

      // 滚动时同步进度条
      let ticking = false;
      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrollLeft = scrollBox.scrollLeft;
            const maxScroll = scrollBox.scrollWidth - scrollBox.clientWidth;
            if (maxScroll <= 0) return;
            const ratio = scrollLeft / maxScroll;
            if (this.$refs.timelineProgress) {
              this.$refs.timelineProgress.style.width = `${ratio * 100}%`;
            }
            const index = Math.round(ratio * (this.timeline.length - 1));
            const clamped = Math.max(
              0,
              Math.min(this.timeline.length - 1, index)
            );
            if (clamped !== this.currentIndex) {
              this.currentIndex = clamped;
            }
            ticking = false;
          });
          ticking = true;
        }
      };
      scrollBox.addEventListener("scroll", onScroll, { passive: true });
      this.timelineScrollBox = scrollBox;

      // 初始化样式
      scrollBox.style.cursor = "grab";
      scrollBox.style.scrollBehavior = "auto"; // 禁用CSS平滑滚动，避免与JS冲突
      scrollBox.style.touchAction = "none"; // 优化触摸设备体验
    },
    syncScrollToIndex(index) {
      if (!this.timelineScrollBox) return;
      const maxScroll =
        this.timelineScrollBox.scrollWidth - this.timelineScrollBox.clientWidth;
      if (maxScroll <= 0) return;
      const ratio = index / Math.max(1, this.timeline.length - 1);
      this.timelineScrollBox.scrollLeft = ratio * maxScroll;
    },
    openModal(src) {
      // 先尝试高清图，失败再回退原图
      const parts = src.split(".");
      const ext = parts.pop();
      const base = parts.join(".");
      const hdSrc = `${base}@2x.${ext}`;
      // 临时图片用于检测高清图是否存在
      const tester = new Image();
      tester.onload = () => {
        this.modalSrc = hdSrc;
      };
      tester.onerror = () => {
        this.modalSrc = src;
      };
      tester.src = hdSrc;
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
      this.modalSrc = "";
    },
    setStage(idx) {
      this.smoothScrollToIndex(idx);
    },
    smoothScrollToIndex(idx) {
      const scrollBox = this.timelineScrollBox;
      if (!scrollBox) return;
      const maxScroll = scrollBox.scrollWidth - scrollBox.clientWidth;
      if (maxScroll <= 0) return;
      const ratio = idx / Math.max(1, this.timeline.length - 1);
      const targetLeft = ratio * maxScroll;
      scrollBox.style.scrollBehavior = "smooth";
      scrollBox.scrollLeft = targetLeft;
      const onScrollEnd = () => {
        this.currentIndex = idx;
        scrollBox.removeEventListener("scroll", onScrollEnd, { passive: true });
      };
      scrollBox.addEventListener("scroll", onScrollEnd, {
        passive: true,
        once: true,
      });
    },
    onWheel(e) {
      const direction = e.deltaY > 0 ? 1 : -1;
      const next = this.currentIndex + direction;
      if (next >= 0 && next < this.timeline.length) {
        this.currentIndex = next;
      }
    },
    selectYear(year) {
      this.activeYear = year;
    },
    onTimelineSlideChange(swiper) {
      // 可扩展：滑动到某阶段时自动选中
    },
    fetchData() {
      apiServe.getHistoryData({}, "get").then((res) => {
        console.log(res, "我是查询接口返回的数据");
        this.GoinData = res.data;
        if (res.data && res.data.category && Array.isArray(res.data.category)) {
          this.categoryData = res.data.category;
        }
        if (res.data && res.data.history && Array.isArray(res.data.history)) {
          // 按weigh升序排序
          this.historyData = res.data.history.sort((a, b) => a.weigh - b.weigh);
        }
      });
      apiServe.getHonorsData({}, "get").then((res) => {
        console.log(res, "我是查询接口返回的数据");
        if (res.data && Array.isArray(res.data)) {
          this.honorImages = res.data;
        }
      });
      apiServe.getCopyWriting({}, "get").then((res) => {
        this.copywriting = res.data;
      });
      let data = {};
      apiServe.getIndexData(data, "get").then((res) => {
          console.log("接口返回", res);
          // 强制转为数字，避免空字符串导致 NaN
          this.indexData = {
            zhandi: Number(res.data.zhandi) || 0,
            ztouzi: Number(res.data.ztouzi) || 0,
            chanzhi: Number(res.data.chanzhi) || 0
          };
          // 数据就绪后再监听数字区域
          this.$nextTick(() => this.observeNumBox());
        })
        .catch((err) => {
          console.error("getIndexData 失败", err);
        });

    },

    initAnimations() {
      this.animationObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("wow-animate");
              this.animationObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );

      const elements = [
        ...document.querySelectorAll(".section-title"),
        ...document.querySelectorAll(".num-box"),
        ...document.querySelectorAll(".text-box"),
        ...document.querySelectorAll(".text-img"),
        ...document.querySelectorAll(".lunbo"),
        ...document.querySelectorAll(".lunbo2"),
      ];

      elements.forEach((el) => this.animationObserver.observe(el));
    },
    observeNumBox() {
      this.numObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.showNum) {
              this.showNum = true;
              this.countUp("animatedArea", this.indexData.zhandi, 0);
              this.countUp("animatedInvest", this.indexData.ztouzi, 0);
              this.countUp("animatedOutput", this.indexData.chanzhi, 0);
              this.numObserver.disconnect();
            }
          });
        },
        { threshold: 0.5 }
      );
      this.numObserver.observe(this.$refs.numBox);
    },
    countUp(key, target, current) {
      const duration = 1500;
      const start = current;
      const distance = target - start;
      let startTime = null;
      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const val = Math.floor(start + distance * progress);
        this[key] = val;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this[key] = target;
        }
      };
      requestAnimationFrame(step);
    },
    // animateNumber(key, target, duration = 1500) {
    //   const start = 0;
    //   const startTime = performance.now();
    //   const step = (currentTime) => {
    //     const elapsed = currentTime - startTime;
    //     const progress = Math.min(elapsed / duration, 1);
    //     const current = Math.floor(
    //       start + (target - start) * this.easeOutQuad(progress)
    //     );
    //     this[key] = current;
    //     if (progress < 1) {
    //       requestAnimationFrame(step);
    //     }
    //   };
    //   requestAnimationFrame(step);
    // },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    onHonorSlideChange(swiper) {
      // 每次切换后强制更新，防止累积偏移
      swiper.update();
    },
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>
<style src="../assets/fazhan.css" scoped></style>
<style scoped>
@media (max-width: 768px) {
  .history-box {
    height: 120vw; /* 移动端更高比例 */
  }
}
.responsive-img {
  width: 100%;
  height: auto;
  display: block;
}
.responsive-video {
  display: block;
  width: 70%;
  margin: 2rem auto;
}
@media (max-width: 768px) {
  .responsive-video {
    width: 90%;
  }
}
.section1 {
  padding: 5rem 0;
  background-color: #f7f7f7;
}
.section2 {
  padding: 0 0 6rem 0;
}
.section3 {
  padding: 3rem 0;
}
.section-title {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 500;
}
.section-title2 {
  margin-bottom: 3rem;
}
.text-box {
  width: 70%;
  margin: 0 auto;
  line-height: 2rem;
  text-indent: 2em;
  font-size: 1.2rem;
}
.text-box p {
  margin-bottom: 1rem;
}

.text-img {
  /* display: block;
  margin: 5rem auto; */
  width: 100%;
  max-width: 1590px;
  height: 600px;
}
.num-box {
  max-width: 70%;
  width: 100%;
  margin: 3rem auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.num-item {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.num-item.show {
  opacity: 1;
  transform: translateY(0);
}

.section-title,
.num-box,
.text-box,
.text-img,
.lunbo,
.lunbo2 {
  opacity: 0;
  transition: all 0.8s ease;
}

.section-title {
  transform: translateY(30px);
}

.text-box {
  transform: translateX(-30px);
}

.text-img {
  transform: translateX(30px);
}

.lunbo,
.lunbo2 {
  transform: scale(0.95);
}

.section-title.wow-animate,
.num-box.wow-animate,
.text-box.wow-animate,
.text-img.wow-animate,
.lunbo.wow-animate,
.lunbo2.wow-animate {
  opacity: 1;
  transform: none;
}
.num-item {
  height: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.num-item p > span {
  font-size: 20px;
  color: #e60013;
}
.num-item p:first-child {
  font-size: 60px;
  color: #e60013;
}
/* 所有年份一行展示 */
.timeline-all-years {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  padding: 2rem 0 1rem;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* 两端渐变遮罩，首尾过渡更自然 */
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    #000 5%,
    #000 95%,
    transparent 100%
  );
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* 禁止文本选择 */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.timeline-all-years::-webkit-scrollbar {
  display: none;
}
.timeline-all-years-wrap {
  display: flex;
  gap: 1.5rem;
  padding: 0 3rem;
  align-items: stretch;
  transition: transform 0.3s ease-out;
}
.timeline-year-card {
  flex: 0 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 2rem 2.4rem;
  width: 260px;
  white-space: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.timeline-year-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
.timeline-year-card .timeline-year-label {
  font-size: 1.9rem;
  font-weight: 600;
  color: #e60013;
  margin-bottom: 1.2rem;
  display: block;
  letter-spacing: 0.5px;
}
.timeline-year-card .timeline-year-content {
  font-size: 1.4rem;
  line-height: 1.7;
  color: #444;
  flex: 1;
}
/* 阶段分割线 */
.separator {
  flex: 0 0 5px;
  background: #ccc;
  margin: 5rem 0;
  border-radius: 1px;
}
/* 同步滚动条视觉 */
.timeline-all-years::-webkit-scrollbar-track {
  background: transparent;
}
.timeline-all-years::-webkit-scrollbar-thumb {
  background: #e60013;
  border-radius: 4px;
}
/* 轮播容器固定高度，确保可见 */
.lunbo {
  width: 70%;
  margin: 0 auto;
  height: 430px;
  position: relative;
}
.swiper {
  height: 100%;
}
.swiper img {
  width: 90%;
  height: 100%;
  margin: 1rem auto;
  object-fit: cover;
}
.swiper-slide-year {
  font-size: 1.5rem;
  color: #000;
  /* margin-bottom: 1rem; */
  padding: 10px;
}
.swiper-slide-p {
  position: relative;
  padding-left: 1.2em;
  width: 90%;
  line-height: 1.5;
}
.swiper-slide1 span {
  position: absolute;
  left: 0;
  top: 0.35em;
  font-size: 30px;
  color: #ed4856;
  line-height: 1;
  transform: translateY(-50%);
}

.swiper-slide-content img {
  transition: transform 0.3s;
  padding: 10px;
  box-sizing: border-box;
}
.swiper-slide1:first-child {
  margin-left: 17px; /* 左移第一张，使放大后完整可见 */
}

/* 荣誉资质轮播箭头 */
.swiper-button-prev-honor,
.swiper-button-next-honor {
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  background: #14419e;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 10px;
}
::v-deep(.swiper-button-prev-honor svg),
::v-deep(.swiper-button-next-honor svg) {
  width: 25%;
}
.swiper-button-next-honor:active,
.swiper-button-prev-honor:active {
  background: #e60013;
}
.swiper-button-next-honor {
  right: 35px;
}
.swiper-button-prev-honor {
  left: 35px;
}

.dap {
  /* width: 100%; */
  width: 70%;
  margin: 0 auto;
  height: 560px;
  overflow: hidden;
  position: relative;
  display: flex;
  background-repeat: no-repeat;
}
@media (max-width: 1640px) {
  .dap {
    width: 65%;
  }
}
.dap > div {
  flex: 1;
  border-right: 1px solid #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
}
.dap > div h2 {
  margin-top: 22rem;
  font-size: 2.7rem;
  margin-bottom: 2rem;
  font-weight: 500;
}
.dap > div p {
  font-size: 1.2rem;
  line-height: 2rem;
  font-weight: 300;
}
.dap div:last-child {
  border-right: none;
}
.honor-text {
  color: rgb(92, 91, 91);
  font-size: 1.6rem;
  line-height: 1;
  text-align: center;
  margin: 0 auto;
  max-width: 80%;
}
.lunbo2 {
  width: 80%;
  margin: 3rem auto 0;
  position: relative;
}

.honor-slide {
  height: auto;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
}
.honor-slide > div {
  flex: 0 0 calc(25% - 60px);
}
.honor-box {
  /* flex: 0 0 calc(25% - 30px); */
  height: 200px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-sizing: border-box;
  padding: 1rem 2rem;
}
.honor-box img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}
.honor-desc {
  margin-top: 1rem;
  text-align: center;
}

.timeline-top-content {
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}
.timeline-stage-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
}
.timeline-year-item {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}
.timeline-top-content::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 100%;
  background: linear-gradient(to right, transparent, #f7f7f7);
  pointer-events: none;
}

/* 模态框样式 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
}
.modal-close {
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 40px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}
@media (max-width: 768px) {
  .section1,
  .section2,
  .section3 {
    padding: 2rem 0;
  }
  .section2 {
    padding-top: 0;
  }
  .section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  .text-box,
  .num-box,
  .lunbo,
  /* .section-content1, */
  .lunbo2 {
    width: 100%;
    max-width: 100%;
    padding: 0 1rem;
    box-sizing: border-box;
  }
  .text-img {
    width: 90%;
    margin: 2rem auto;
  }
  .num-box {
    flex-direction: column;
    gap: 1.5rem;
  }
  .num-item {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 0.5rem;
  }
  .num-item p:first-child {
    font-size: 2.8rem;
    margin-bottom: 0;
  }
  .num-item p:last-child {
    font-size: 1.2rem;
    color: #333;
  }
  .num-item p > span {
    font-size: 1rem;
  }
  .lunbo {
    height: auto;
    padding: 0 1rem;
  }
  .swiper-button-next,
  .swiper-button-prev,
  .swiper-button-next-honor,
  .swiper-button-prev-honor {
    width: 32px;
    height: 32px;
    right: 5px;
    left: auto;
    transform: translateY(-50%);
  }
  .swiper-button-prev,
  .swiper-button-prev-honor {
    left: 5px;
    right: auto;
  }
  .dap {
    width: 80%;

    flex-direction: column;
    height: auto;
    background-size: cover;
    /* padding: 1rem; */
  }
  .dap > div {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding: 2rem 1rem;
    text-align: center;
  }
  .dap > div:last-child {
    border-bottom: none;
  }
  .dap > div h2 {
    margin-top: 0;
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
  .dap > div p {
    font-size: 1.2rem;
    line-height: 1.6;
  }
  .honor-text {
    max-width: 100%;
    font-size: 1.2rem;
    padding: 0 1rem;
    line-height: 1.6;
  }
  .honor-slide {
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 1rem;
  }
  .honor-box {
    width: 100%;
    height: 150px;
    margin-bottom: 1rem;
  }
  .honor-desc {
    font-size: 0.9rem;
  }
  .swiper-slide-year {
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .swiper-slide-p {
    display: block;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 1rem;
    line-height: 1.5;
  }
  /* 移动端发展历程图片缩小并居中 */
  .swiper-slide-content img {
    width: 60%;
    height: auto;
    margin: 0.5rem auto;
    display: block;
  }
}
/* 横向时间轴样式 */
.timeline-top-content {
  position: relative;
  overflow: hidden;
  height: 200px;
  max-width: 90%;
  margin: 0 auto 2rem;
}
.timeline-stage-panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition: transform 0.5s ease;
}
.timeline-stage-title {
  font-size: 1.8rem;
  color: #14419e;
  margin-bottom: 1rem;
  text-align: center;
}
.timeline-year-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}
.timeline-year-item {
  background: #f7f7f7;
  border-left: 4px solid #ccc;
  padding: 0.8rem 1.2rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  max-width: 260px;
}
.timeline-year-item.active {
  border-left-color: #e60013;
  background: #fff3f3;
}
.timeline-year-label {
  font-weight: 600;
  color: #333;
  display: block;
  margin-bottom: 0.4rem;
}
.timeline-year-content {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
}
.timeline-box {
  position: relative;
  max-width: 90%;
  margin: 0 auto;
  overflow: hidden;
}
.timeline-progress-container {
  position: relative;
  height: 4px;
  width: 100%;
  margin-bottom: 1rem;
}
.timeline-line {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #e0e0e0;
}
.timeline-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #e60013;
  transition: width 0.2s ease;
}
.timeline-track {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
}
.timeline-stage-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}
.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #14419e;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #ccc;
  margin-bottom: 0.5rem;
  transition: all 0.3s;
}
.timeline-stage-name {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
  text-align: center;
}
.timeline-stage-node:hover .timeline-dot,
.timeline-stage-node.active .timeline-dot {
  background: #e60013;
  box-shadow: 0 0 0 2px #e60013;
}
.timeline-prev,
.timeline-next {
  position: absolute;
  top: 16px;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  background: #14419e;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeline-prev {
  left: -40px;
}
.timeline-next {
  right: -40px;
}
::v-deep(.timeline-prev svg),
::v-deep(.timeline-next svg) {
  width: 25%;
}
/* 阶段分割线：色带+悬浮标签 */
.separator {
  position: relative;
  flex-shrink: 0;
  width: 60px;
  height: 320px;
  background: linear-gradient(90deg, #e60013 0%, #f0f0f0 100%);
  margin: 0 8px;
  pointer-events: none; /* 不干扰拖拽 */
}
.separator::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: inherit;
}
/* 悬浮阶段标签 */
.stage-tag {
  position: absolute;
  left: 50%;
  top: -28px;
  transform: translateX(-50%);
  background: #e60013;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 2;
}
</style>